import React, { Component } from 'react'
import { Container, Row, Col, Card, Button, Badge, DropdownButton, Dropdown } from 'react-bootstrap';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from "moment";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import "./_leadManagement.scss"
import LeadAssign from './LeadAssign';
import LeadAndEmployeeCreationModal from './LeadAndEmployeeCreationModal';
import LeadsModalDetails from './LeadsModalDetails';



class LeadManagementHome extends Component {

  constructor(props) {
    super(props);
    this.state = {
      leadAssigningModal: false,
      employeeCreationModal: false,
      is_grouping: true,
      nextLevelUserAndEmployeeDetails: this.props.getNextLevelUserAndEmployeeDetails,
      leadTaskStatusDetails: this.props.getLeadTaskStatusDetails,
      loading: 0,
      nextLevelEmp: [],
      userLevelArrFromBreadCrumb: [],
      nextLevelUserDetailsModal: false,
      selectedCardData: [],
    };
  }

  nextLevelUserAndEmployeeDetailsHandle = async (val, group, name) => {

    this.setState({ loading: 1 });

    const result = await this.props.client.query({
      query: gql`
        query($institute_id: Int!,$branch_id: Int!,$head_employee_id: Int!,$is_grouping: Boolean!) {
          getNextLevelUserAndEmployeeDetails(institute_id: $institute_id,branch_id: $branch_id,head_employee_id: $head_employee_id,is_grouping: $is_grouping) {
            level_id
            employee_id
            employee_name
            next_level_emp
            status_details
          }
        }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(Cookies.get("branch_id")),
        head_employee_id: parseInt(val),
        is_grouping: group,
      },
      fetchPolicy: 'network-only',
    })

    if (result.data.getNextLevelUserAndEmployeeDetails.length > 0) {
      console.log("group", group);
      let data = result.data.getNextLevelUserAndEmployeeDetails;
      this.setState({ nextLevelUserAndEmployeeDetails: data, loading: 0, nextLevelEmp: data[0].next_level_emp })
    } else {
      this.setState({ loading: 0, nextLevelEmp: 0, })
    }

  }


  breadCumbAdding = (val, group, name) => {

    let breadCumAddingData = [];
    if (this.state.userLevelArrFromBreadCrumb.length > 0) {
      this.state.userLevelArrFromBreadCrumb.map((item) => {
        breadCumAddingData.push({ ...item, is_clicked: true })
      })
    }
    breadCumAddingData.push({ employee_id: val, employee_name: name, is_clicked: false });

    this.setState({ userLevelArrFromBreadCrumb: breadCumAddingData })

    this.nextLevelUserAndEmployeeDetailsHandle(val, group);
  }

  breadCumDeleting = (id, group, level, ind) => {
    if (level == "main") {
      this.setState({ userLevelArrFromBreadCrumb: [] });
      this.nextLevelUserAndEmployeeDetailsHandle(id, group);
    } else {

      let remainingBreadcumb = [];
      this.state.userLevelArrFromBreadCrumb.filter((item, index) => index <= ind).map((item1) => {
        if (item1.employee_id == id) {
          remainingBreadcumb.push({ ...item1, is_clicked: false })
        } else {
          remainingBreadcumb.push(item1)
        }
      })
      this.setState({ userLevelArrFromBreadCrumb: remainingBreadcumb })
      this.nextLevelUserAndEmployeeDetailsHandle(id, group);
    }
  }


  nextPageFunc = () => {
    this.props.history.push({
      pathname: "/lead-management/leads_followups",
      back: "/lead-management"
    });
  }


  render() {

    console.log("haari", this.state)

    return (
      <Container>
        <Row>
          <Col xl={12} lg={12} md={12} sm={12}>
            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
              <h2 className="title h5 mb-0" style={{ marginTop: "30px" }}>User Management</h2>
              <div className='d-flex justify-content-end'>
                <div style={{ marginTop: "30px" }}>
                  <button className="employee-creation" onClick={() => { this.setState({ employeeCreationModal: true }) }}>Employee Creation</button>
                </div>
                <div className='ml-2'>
                  <button className="lead-assign" onClick={() => { this.setState({ leadAssigningModal: true }) }}>Lead Assign</button>
                </div>
              </div>
            </div>
          </Col>

          {
            this.state.leadTaskStatusDetails.length > 0 ? (
              <>
                <div className='mt-2' style={{ marginLeft: "18px" }}>
                  <h6>My Task</h6>
                </div>
                <Col sm={12}>
                  {
                    this.state.leadTaskStatusDetails.map((item) => {
                      return (
                        <>
                          <Card className='mt-2 cardboarder'>
                            <div className='d-flex justify-content-center align-items-center mx-3'>
                              <div>
                                <Card.Body>
                                  <Row>
                                    {
                                      item.lead_status_details.map((item1) => {
                                        return (
                                          <>
                                            <Col sm={3}>
                                              <Card className='backcard mt-2' onClick={() => { this.setState({ nextLevelUserDetailsModal: true, selectedCardData: item1.lead_details }) }} style={{ cursor: "pointer" }}>
                                                <Card.Body>
                                                  <h6>{item1.status_name}: {item1.status_count}</h6>
                                                </Card.Body>
                                              </Card>
                                            </Col>
                                          </>
                                        )
                                      })
                                    }
                                  </Row>
                                </Card.Body>
                              </div>
                              <div>
                                <i className="fa fa-arrow-circle-right" onClick={() => this.nextPageFunc()} style={{ cursor: "pointer", fontSize: "26px" }}></i>
                              </div>
                            </div>
                          </Card>
                        </>
                      )
                    })
                  }
                </Col>
              </>
            ) : ("")
          }

          {
            this.state.nextLevelUserAndEmployeeDetails.length > 0 ? (
              <>

                <div className='mt-5' style={{ marginLeft: "18px" }}>
                  <h6>Next Level Users</h6>
                </div>
                <Col sm={12}>
                  <div className='my-2'>
                    <ul className="list-inline breadcrumb-nav">
                      <li onClick={() => { this.breadCumDeleting(parseInt(Cookies.get("id")), true, "main") }}><i className="fas fa-home" /><i className='fas fa-chevron-circle-right ml-2' /></li>
                      {
                        this.state.userLevelArrFromBreadCrumb.map((item, index) => {
                          return (
                            item.is_clicked ? (

                              <li onClick={() => { this.breadCumDeleting(item.employee_id, false, "sub", index) }}>{item.employee_name}<i className='fas fa-chevron-circle-right ml-2'></i></li>
                            ) : (
                              <li className='color_black'>{item.employee_name}</li>
                            )
                          )
                        })
                      }
                    </ul>
                  </div>
                  {

                    this.state.nextLevelUserAndEmployeeDetails.map((item) => {
                      return (
                        <>
                          <Card className='mt-2 cardboarder'>
                            <div className='d-flex justify-content-center align-items-center mx-3'>
                              <div>
                                <Card.Body>
                                  <Row>
                                    <Col sm={3}>
                                      <Card className='next_level_card'>
                                        <Card.Body>
                                          <h6>Name: {item.employee_name}</h6>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col sm={3}>
                                      <Card className='next_level_card'>
                                        <Card.Body>
                                          <h6>Level: {item.level_id}</h6>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col sm={3}>
                                      <Card className='next_level_card'>
                                        <Card.Body>
                                          <h6>Next Level Users: {item.next_level_emp}</h6>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    {
                                      item.status_details.map((item1) => {
                                        return (
                                          <>
                                            <Col sm={3} >
                                              <Card className='next_level_card mt-2' onClick={() => { this.setState({ nextLevelUserDetailsModal: true, selectedCardData: item1.lead_details }) }} style={{ cursor: "pointer" }}>
                                                <Card.Body>
                                                  <h6>{item1.lead_status_type}: {item1.status_count}</h6>
                                                </Card.Body>
                                              </Card>
                                            </Col>
                                          </>
                                        )
                                      })
                                    }
                                  </Row>
                                </Card.Body>
                              </div>
                              <div>
                                {
                                  item.next_level_emp != 0 ? (
                                    <i className="fa fa-arrow-circle-right" onClick={() => { this.breadCumbAdding(item.employee_id, false, item.employee_name) }} style={{ cursor: "pointer", fontSize: "26px" }}></i>
                                  ) : ("")
                                }
                              </div>
                            </div>
                          </Card>
                          <Row>
                            <Col>
                              {
                                this.state.loading == 1 ? (
                                  <Row className="my-2">
                                    <Col>
                                      <div className="spinner-border text-primary text-center loading-img-center"></div>
                                    </Col>
                                  </Row>
                                ) : ("")
                              }
                            </Col>
                          </Row>

                        </>
                      )
                    })
                  }

                </Col>

              </>
            ) : ("")
          }


        </Row>

        <LeadAssign
          globals={this.props.globals}
          stateData={this.state}
          show={this.state.leadAssigningModal}
          onHide={() => this.setState({ leadAssigningModal: false })}
        />

        <LeadAndEmployeeCreationModal
          stateData={this.state}
          show={this.state.employeeCreationModal}
          onHide={() => this.setState({ employeeCreationModal: false })}
        />

        <LeadsModalDetails
          stateData={this.state}
          show={this.state.nextLevelUserDetailsModal}
          onHide={() => this.setState({ nextLevelUserDetailsModal: false })}
        />

      </Container>
    );
  }
}

export default withRouter(withApollo(compose(

)(LeadManagementHome))
);